import type { SizeType } from '../../../lib/gramjs';

import { CHANNEL_ID_LENGTH } from '../../../config';

export type EntityType = (
  'sticker' | 'wallpaper' | 'channel' | 'chat' | 'user' | 'photo' | 'webDocument' |
  'document' | 'staticMap'
);

const REAL_MEDIA_ENTITY_ID_REGEX = /^-?\d+(?:[./]\d+)?$/;

function checkIfChannelId(id: string) {
  return id.length === CHANNEL_ID_LENGTH && id.startsWith('-1');
}

export function getEntityTypeById(chatOrUserId: string) {
  if (!chatOrUserId.startsWith('-')) {
    return 'user';
  } else if (checkIfChannelId(chatOrUserId)) {
    return 'channel';
  } else {
    return 'chat';
  }
}

export function parseMediaUrl(url: string) {
  const mediaMatch = url.startsWith('staticMap')
    ? url.match(/(staticMap):([0-9-]+)(\?.+)/)
    : url.startsWith('webDocument')
      ? url.match(/(webDocument):(.+)/)
      : url.match(
        // eslint-disable-next-line max-len
        /(avatar|profile|photo|sticker|wallpaper|document)([-\d\w./]+)(?::\d+)?(\?size=\w+)?/,
      );
  if (!mediaMatch) {
    return undefined;
  }

  const mediaMatchType = mediaMatch[1];
  const entityId: string | number = mediaMatch[2];

  if (mediaMatchType === 'photo' && !REAL_MEDIA_ENTITY_ID_REGEX.test(String(entityId))) {
    return undefined;
  }

  let entityType: EntityType;
  const params = mediaMatch[3];
  const sizeType = params?.replace('?size=', '') as SizeType || undefined;

  if (mediaMatch[1] === 'avatar' || mediaMatch[1] === 'profile') {
    entityType = getEntityTypeById(entityId as string);
  } else {
    entityType = mediaMatch[1] as EntityType;
  }

  return {
    mediaMatchType,
    entityType,
    entityId,
    sizeType,
    params,
  };
}
